import classNames from '@/external/classNames';

type Props = {
  onClick?: () => void;
  className?: string;
  children?: React.ReactNode;
};

const GameHeaderButton: FC<Props> = ({ onClick, className, children }) => (
  <div
    className={classNames(
      'flex items-center justify-center rounded-full w-8 h-8 border border-goten/15 shrink-0',
      className,
    )}
    onClick={onClick}
  >
    <div className="m-auto w-fit">{children}</div>
  </div>
);

export default GameHeaderButton;
